import React from "react";
import { Save } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { createWatchlist } from "@/lib/api";
import { toast } from "sonner";

export default function PlcspWatchlistButton({
    q,
    cpv,
    minBudget,
    maxBudget,
    state,
}) {
    const navigate = useNavigate();
    const onClick = async () => {
        const name = window.prompt(
            "Nombre para esta búsqueda guardada:",
            q ? `${q}${cpv ? " · CPV " + cpv : ""}` : "Búsqueda PLCSP",
        );
        if (!name) return;
        try {
            await createWatchlist({
                name,
                q,
                cpv,
                min_budget: minBudget ? Number(minBudget) : null,
                max_budget: maxBudget ? Number(maxBudget) : null,
                state,
            });
            toast.success(
                "Búsqueda guardada — recibirás alertas cuando aparezcan novedades",
                {
                    action: {
                        label: "Ver alertas",
                        onClick: () => navigate("/app/alertas"),
                    },
                },
            );
        } catch {
            toast.error("No se pudo guardar");
        }
    };
    return (
        <Button
            variant="outline"
            onClick={onClick}
            className="rounded-full border-brand-200 bg-brand-50 hover:bg-brand-100 text-brand-700 h-9 px-4 font-bold gap-1.5"
            data-testid="plcsp-save-watchlist-btn"
        >
            <Save size={13} />
            Guardar esta búsqueda como alerta
        </Button>
    );
}
